export const ACTIONS_ACTIONS = {
  list: {
    request: "ACTIONS/LIST_REQUEST",
    success: "ACTIONS/LIST_SUCCESS",
    error: "ACTIONS/LIST_ERROR"
  },
  reset: "ACTIONS/RESET_STATE"
};
